import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld' 
import Maps from '@/components/Maps' 
import PlayList from '@/components/funnyplay/List'
import PlayRecruit from '@/components/funnyplay/Recruit' 
import HotelList from '@/components/service/List' 
import Test from '@/components/test'

import News from '@/components/News' 
import vr from '@/components/VR' 
import Navigation from '@/components/Navigation' 
import Comments from '@/components/comments' 

//活动组件

import act1Index from '@/components/act/1/Index.vue' 
import act1Main from '@/components/act/1/main.vue'  
import act1NewsList from '@/components/act/1/NewsList.vue'  
import act1Banner from '@/components/act/1/Banner.vue'

import act2Index from '@/components/act/2/Index.vue' 
import act2Main from '@/components/act/2/main.vue'  
import act2Banner from '@/components/act/2/Banner.vue'

import act3Index from '@/components/act/3/Index.vue' 
import act3Main from '@/components/act/3/main.vue'  
import act3Banner from '@/components/act/3/Banner.vue'

import act4Index from '@/components/act/4/Index.vue' 
import act4Main from '@/components/act/4/main.vue'  
import act4NewsList from '@/components/act/4/NewsList.vue'  
import act4Banner from '@/components/act/4/Banner.vue'

import act5Index from '@/components/act/5/Index.vue' 
import act5Main from '@/components/act/5/main.vue' 
import act5Banner from '@/components/act/5/Banner.vue' 
import act5Article from '@/components/act/5/Article.vue' 

import act6Index from '@/components/act/6/Index.vue' 
import act6Banner from '@/components/act/6/Banner.vue' 

import act7Index from '@/components/act/7/Index.vue' 
import act7Banner from '@/components/act/7/Banner.vue' 
import act7Main from '@/components/act/7/Main.vue' 

import act8Index from '@/components/act/8/Index.vue' 
import act8Banner from '@/components/act/8/Banner.vue' 
import act8Main from '@/components/act/8/Main.vue' 
import act8NewsList from '@/components/act/8/NewsList.vue' 


import act10Index from '@/components/act/10/Index.vue' 
import act10Banner from '@/components/act/10/Banner.vue' 
import act10NewsList from '@/components/act/10/NewsList.vue'  


import act13NewsList from '@/components/act/13/NewsList.vue'  


import act14NewsList from '@/components/act/14/NewsList.vue'  
import act17NewsList from '@/components/act/17/NewsList.vue'  
import act18NewsList from '@/components/act/18/NewsList.vue'  
import act19NewsList from '@/components/act/19/NewsList.vue'  
import act20NewsList from '@/components/act/20/NewsList.vue'  
import act22NewsList from '@/components/act/22/NewsList.vue'  

Vue.use(Router)

export default new Router({
  //mode: 'history',//去掉#，
  //base: '/inliuzhou/2018/LiuzhouTourism/',//这个配置也很重要，否则会出现页面空白情况
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld,
      query:{view:1},
      meta: {
            title: '首页'
        }
    },
    {
      path: '/test',
      name: 'test',
      component: Test
    },
    {
      path: '/Maps',
      name: 'Maps',
      component: Maps
    },
    {
      path: '/NewsList',
      name: 'NewsList',
      component: act4NewsList,
      query:{type:1,id:1}
    },
    {
      path: '/PlayList',
      name: 'PlayList',
      component: PlayList
    },
    {
      path: '/PlayRecruit',
      name: 'PlayRecruit',
      component: PlayRecruit,
      query:{id:1}
    },
    {
      path: '/HotelList',
      name: 'HotelList',
      component: HotelList
    },
    {
      path: '/act1',
      name: '2019春节闲游宝典',
      component: act1Index,
      children: [
        {
          path: '',
          component: act1Banner
        },
        {
          path: 'main',
          component: act1Main,
        },
        {
          path: 'main/newslist',
          component: act1NewsList,
        },
        {
          path: 'main/news',
          name: '资讯',
          component: News
        },
        {
          path: 'main/vr',
          name: 'VR',
          component: vr
        },
        {
          path: 'main/comments',
          name: '资讯评论',
          component: Comments
        },
      ]
    },
   { 
    path: '/navigation',
    name: '导航',
    component: Navigation,
  },
    {
      path: '/act2',
      name: '苗族系列坡会群',
      component: act2Index,
      children: [
        {
          path: '',
          component: act2Banner
        },
        {
          path: 'main',
          component: act2Main,
        },
        {
          path: 'main/news',
          name: '资讯',
          component: News
        },
        {
          path: 'main/vr',
          name: 'VR',
          component: vr
        },
      {
          path: 'main/comments',
          name: '资讯评论',
          component: Comments
        },
      ]
    },
    {
      path: '/act3',
      name: '大战歌',
      component: act3Index,
      children: [
        {
          path: '',
          component: act3Banner
        },
        {
          path: 'main',
          component: act3Main,
        },
      ]
    },
    {
      path: '/act4',
      name: '三月三，去撒欢',
      component: act4Index,
      children: [
        {
          path: '',
          component: act4Banner
        },
        {
          path: 'main',
          component: act4Main,
        },
        {
          path: 'main/newslist',
          component: act4NewsList,
        },
        {
          path: 'main/news',
          name: '资讯',
          component: News
        },
        {
          path: 'main/vr',
          name: 'VR',
          component: vr
        },
      {
          path: 'main/comments',
          name: '资讯评论',
          component: Comments
        },
      ]
    },
    {
      path: '/act5',
      name: '斗牛',
      component: act5Index,
      children: [
        {
          path: '',
          component: act5Banner
        },
        {
          path: 'main',
          component: act5Main,
        },
        {
          path: 'main/article',
          name: '斗牛文章',
          component: act5Article
        }
      ]
    },
    {
      path: '/act6',
      name: '2019文博旅游艺术周',
      component: act6Index,
      children: [
        {
          path: '',
          component: act6Banner
        }
      ]
    },
    {
      path: '/act7',
      name: '夏日赏荷卷',
      component: act7Index,
      children: [
        {
          path: '',
          component: act7Banner
        },
        {
          path: 'main',
          component: act7Main,
        },
        {
          path: 'main/newslist',
          component: act4NewsList,
        },
        {
          path: 'main/news',
          name: '资讯',
          component: News
        },
        {
          path: 'main/vr',
          name: 'VR',
          component: vr
        },
      {
          path: 'main/comments',
          name: '资讯评论',
          component: Comments
        },
      ]
    },
    {
      path: '/act8',
      name: 'ACT-8',
      component: act8Index,
      children: [
        {
          path: '',
          component: act8Banner
        },
        {
          path: 'main',
          component: act8Main,
        },
        {
          path: 'main/newslist',
          component: act8NewsList,
        },
        {
          path: 'main/news',
          name: '资讯',
          component: News
        },
        {
          path: 'main/vr',
          name: 'VR',
          component: vr
        },
      {
          path: 'main/comments',
          name: '资讯评论',
          component: Comments
        },
      ]
    },
    {
      path: '/act10',
      name: '2019文博旅游艺术周',
      component: act10Index,
      children: [
        {
          path: '',
          component: act10Banner
        },
        {
          path: 'newslist',
          component: act10NewsList,
        },
      ]
    },
    {
      path: '/act13',
      name: 'newslist',
      component: act13NewsList
    },
    {
      path: '/act14',
      name: 'newslist',
      component: act14NewsList
    },
    {
      path: '/act17',
      name: 'newslist',
      component: act17NewsList
    },
    {
      path: '/act18',
      name: 'newslist',
      component: act18NewsList
    },
    {
      path: '/act19',
      name: 'newslist',
      component: act19NewsList
    },
    {
      path: '/act20',
      name: 'newslist',
      component: act20NewsList
    },
    {
      path: '/act22',
      name: 'newslist',
      component: act22NewsList
    },
  ]
})
/*
 
 * 
 * 
 * 
 * */


// WEBPACK FOOTER //
// ./src/router/index.js